export enum AuditType {
  CREATE = 'Created',
  UPDATE = 'Updated',
  DELETE = 'Deleted',
}

export enum TemplateMode {
  CREATE = 'create',
  EDIT = 'edit',
  VIEW = 'view',
  COPY = 'copy',
}

// Display-only labels for template sections whose stored/submitted
// sectionName must stay unchanged (payload, gating (BipTileSection.Data =
// 'Reports') and print pipelines all key off the static name) — "Reports"
// reads as "Behavior Data" wherever it's shown to the user, since this
// section is where behavior data collection lives, not report generation.
export const SECTION_DISPLAY_NAMES: Partial<Record<string, string>> = {
  Reports: 'Behavior Data',
};
